export const KeyCode = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,

  SPACEBAR: 32,
  ENTER: 13,
  DELETE: 46,
  SHIFT: 16,
  CONTROL: 17,
  ALT: 18,
  META: 224,
  ESCAPE: 27,
  BACKSPACE: 8,
  F2: 113,

  OPEN_SQ_BRACKET: 219,
  CLOSE_SQ_BRACKET: 221,

  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90
};

export const ZIndexLevel = {
  LOWEST_LEVEL: 1,
  LOWEST_HIGHER: 10,
  MIDDLE_LEVEL: 20,
  MIDDLE_HIGHER: 30,
  HIGHEST_LEVEL: 40,
  HIGHEST_HIGHER: 50
}

export const TABS = {
  EXTERNAL_FILES: { LABEL: 'EXTERNAL FILES', KEY: 'EXTERNAL_FILES' },
  HOME: { LABEL: 'HOME', KEY: 'HOME' },
  ASSETS: { LABEL: 'ASSETS', KEY: 'ASSETS' },
  COLLECTIONS: { LABEL: 'COLLECTIONS', KEY: 'COLLECTIONS' },
  REPORTING: { LABEL: 'REPORTING', KEY: 'REPORTING' }
};

export const SUBTAB = {
  ALL: { LABEL: 'ALL', KEY: 'ALL' },
  BROWSE: { LABEL: 'BROWSE', KEY: 'BROWSE' },
  SEARCH: { LABEL: 'SEARCH', KEY: 'SEARCH' },
  NONE: { LABEL: 'NONE', KEY: 'NONE' }
};

export const BROWSE_EXT_CONSTANT = {
  NODE_TYPE: {
    FILE: 'FILE',
    FOLDER: 'FOLDER'
  },
  STATUS: {
    INGESTED: 'INGESTED',
    NOT_INGESTED: 'NOT-INGESTED'
  },
  KEYS: {
    ROOT: '/'
  }
};

export const ACTION_MODALS = {
  NULL: null,
  RENAME_MODAL: 'RENAME_MODAL',
  DELETE_MODAL: 'DELETE_MODAL',
  ARCHIVE_MODAL: 'ARCHIVE_MODAL',
  RESTORE_MODAL: 'RESTORE_MODAL',
  NEW_FOLDER_MODAL: 'NEW_FOLDER_MODAL',
  SMART_COPY_MODAL: 'SMART_COPY_MODAL',
  SMART_LINK_MODAL: 'SMART_LINK_MODAL',
  ADD_TO_COLLECTION_MODAL: 'ADD_TO_COLLECTION_MODAL',
  S3_UPLOAD_MODAL: 'S3_UPLOAD_MODAL',
  EXT_FILE_INFO_MODAL: 'EXT_FILE_INFO_MODAL',
  COMPARE_VIEW_MODAL: 'COMPARE_VIEW_MODAL',
  ARCHIVE_DETAILS_MODAL: 'ARCHIVE_DETAILS_MODAL',
  PROGRESS_MODAL: 'PROGRESS_MODAL',
  EDIT_METADATA_MODAL: 'EDIT_METADATA_MODAL',
  FOLDER_DETAILS_MODAL: 'FOLDER_DETAILS_MODAL',
  ADD_SPOTLIGHT_MODAL: 'ADD_SPOTLIGHT_MODAL',
  PURGE_MODAL: 'PURGE_MODAL',
  REMOVE_MODAL: 'REMOVE_MODAL',
  SHARE_VIA_EMAIL: 'SHARE_VIA_EMAIL'
};

export const PdfPreviewOption = {
  PAGE_BY_PAGE: 'PAGE_BY_PAGE',
  CONTINUOUS: 'CONTINUOUS'
};

export const VIEW = {
  GRID: 'GRID',
  LIST: 'LIST'
};

export const pdfPreviewOptions = [
  { value: PdfPreviewOption.PAGE_BY_PAGE, label: 'Page by Page' },
  { value: PdfPreviewOption.CONTINUOUS, label: 'Continuous Page' }
];

export const fontFamilyOptions = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Courier New', label: 'Courier New' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Times New Roman', label: 'Times New Roman' }
];

export const advSrchMatchStrOptions = [
  { value: 'CONTAINS', label: 'Contains' },
  { value: 'NOT_CONTAINS', label: 'Not Contains' },
  { value: 'BEGINS_WITH', label: 'Begins With' },
  { value: 'ENDS_WITH', label: 'Ends With' },
  { value: 'EXACT', label: 'Matches Exactly' }
];

export const advSrchExactMatchStrOptions = [
  { value: 'EXACT', label: 'Is' },
  { value: 'NOT_CONTAINS', label: 'Not' }
];

export const COLLECTION_INVITE_SHARE_TYPE = {
  INVITE_WITH_LINK: 'with_link',
  INVITE_WITH_LINK_AND_PASSWORD: 'with_link_and_password',
}

export const CommentFilterOption = {
  UNRESOLVED: 'UNRESOLVED',
  RESOLVED: 'RESOLVED',
  ALL: 'ALL'
};

export const CommentSortOption = {
  BY_MODIFICATION_DATE: 'BY_MODIFICATION_DATE',
  BY_DATE_ADDED: 'BY_DATE_ADDED',
  BY_AUTHOR: 'BY_AUTHOR',
  BY_VIDEO_TIME: 'BY_VIDEO_TIME'
};

export const PathActionOptions = [
  { value: 'ADDED', label: 'Added' },
  { value: 'DELETED', label: 'Deleted' },
  { value: 'MOVED', label: 'Moved' },
  { value: 'RENAMED', label: 'Renamed' },
  { value: 'CONTENT_CHANGED', label: 'Content Changed' },
  { value: 'ARCHIVED', label: 'Archived' },
  { value: 'EXPIRED', label: 'Expired' },
  { value: 'RESTORED', label: 'Restored' },
  { value: 'RESURRECTED', label: 'Resurrected' }
];

export const SmartAssetLinkageRoleOptions = [
  { value: 'SMART_COPY', label: 'Smart Copy' },
  { value: 'SMART_LINK', label: 'Smart Link' },
  { value: 'EITHER', label: 'Either' },
  { value: 'BOTH', label: 'Both' },
];

export const OtherLinkageRoleOptions = [
  { value: 'SMART_COPY_SRC', label: 'Smart Copy Parent' },
  { value: 'SMART_LINK_SRC', label: 'Smart Link Parent' },
  { value: 'COMPONENT', label: 'Component' },
  { value: 'COMPOSITE', label: 'Composite' },
  { value: 'DERIVED', label: 'Derived' },
  { value: 'ORIGINAL', label: 'Original' }
];

export const Visibility = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  HIDING: 'HIDING',
  SHOWING: 'SHOWING'
};

export const CollectionType = {
  STATIC: 'Static',
  DYNAMIC: 'Dynamic'
};

export const DownloadType = { ORIGINAL: 1, PDF: 2, ZIP: 3 };

const MIN_15 = 1000 * 60 * 15;
const MIN_30 = MIN_15 * 2;
const HR_1 = MIN_30 * 2;
const HR_2 = HR_1 * 2;
const HR_4 = HR_2 * 2;
const DAY_1 = HR_4 * 6;
const DAY_2 = DAY_1 * 2;
const DAY_7 = DAY_1 * 7;

export const SEND_NOTIFICATION_TIME_OPTIONS = [
  { value: MIN_15, label: '15 minutes before' },
  { value: MIN_30, label: '30 minutes before' },
  { value: HR_1, label: '1 hour before' },
  { value: HR_2, label: '2 hours before' },
  { value: HR_4, label: '4 hours before' },
  { value: DAY_1, label: '1 day before' },
  { value: DAY_2, label: '2 days before' }
];

export const S3_LINK_EXPIRE_TIME_OPTIONS = [
  { value: HR_2, label: '2 hours' },
  { value: DAY_1, label: '24 hours' },
  { value: DAY_2, label: '48 hours' },
  { value: DAY_7, label: '7 days' }
];

export const PAGE_SIZE = 60;

export const FetchPolicy = {
  CACHE_FIRST: 'CACHE_FIRST',
  CACHE_AND_NETWORK: 'CACHE_AND_NETWORK'
};

export const DATE_FORMAT = 'M/D/Y';
export const DATETIME_FORMAT = 'M/D/Y h:mmA';

export const SORT_BY_KIND = 'KIND';
export const SORT_BY_MTIME = 'MODIFICATION_TIME';

export const SEARCH_TAB = 'SEARCH'; //For search tab constant

export const WAVEPLAYER_DRAWING = 'WAVEPLAYERDRAWING';

//session maintain
export const HISTORY_BEGIN_URL = 'HISTORY_BEGIN_URL';
export const HISTORY_END_URL = 'HISTORY_END_URL';

//Worker Constants
export const GET_ACTIONS = 'GET ACTIONS'

//Advance Search Constants
export const METADATA_KEYS = 'METADATA_KEYS';
export const METADATA_VALUES = 'METADATA_VALUES';
export const METADATA_LOGICAL_RELATIONSHIPS = 'METADATA_LOGICAL_RELATIONSHIPS';
export const SEARCH_STRING = 'SEARCH_STRING';
export const FILE_NAME_MATCH_ENUM = 'FILE_NAME_MATCH_ENUM';
export const VALUE_LENGTH = 'VALUE_LENGTH';
export const HIDE = 'HIDE';
export const PIN_TO_TOP = 'PIN_TO_TOP';
export const SHOW_ALL = 'SHOW_ALL';
export const PATH_PROJECT = 'PATH_PROJECT';
export const AUTHOR = 'AUTHOR';
export const FILE_TYPE = 'FILE_TYPE';
export const CHECK_IN_DATE_RANGE = 'CHECK_IN_DATE_RANGE';
export const COMMENTS = 'COMMENTS';
export const PATH_ACTIONS = 'PATH_ACTIONS';
export const PATH_ACTIONS_NOT = 'PATH_ACTIONS_NOT';
export const LINKAGE_ROLES = 'LINKAGE_ROLES';
export const LINKAGE_ROLES_NOT = 'LINKAGE_ROLES_NOT';
export const ASSET_ID = 'ASSET_ID';

export const WIDTH_OF_FOLDER_NAV = 'WIDTH_OF_FOLDER_NAV';
export const WIDTH_OF_VIDEO_PREVIEW_PANEL = 'WIDTH_OF_VIDEO_PREVIEW_PANEL';
export const Q = 'q';
//Asset VAB Status
export const MODIFIED = 'MODIFIED';
export const NOCHANGE = 'NOCHANGE';
export const ADDED = 'ADDED';
export const SYNCED = 'SYNCED';
export const UNVERSIONED = 'UNVERSIONED';
export const POTENTIAL_CONFLICT = 'POTENTIAL_CONFLICT';
export const CONFLICT = 'CONFLICT';
export const VERSIONED = 'VERSIONED';
export const LOCKED = 'LOCKED';
export const UPTODATE_NEEDED_ICON = 'UPTODATE_NEEDED_ICON';

//S3 Operation Constants
export const UPLOAD_FROM_COMPUTER = 'UPLOAD_FROM_COMPUTER';
export const UPLOAD_FROM_URL = 'UPLOAD_FROM_URL';
export const S3BUCKET = 'S3BUCKET';
export const PUBLIC_URL = 'PUBLIC_URL';
export const ZOOM_S3 = 'ZOOM_S3';
export const CUSTOM_S3 = 'CUSTOM_S3';

export const ORIGNAL_HI_RES = 'hi-res';
export const ZOOM_LOW_RES = 'proxy';
export const ORIGINAL = 'Original';

export const DUPLICATE_RENAME = 'RENAME';
export const DUPLICATE_SKIP = 'SKIP';
export const DUPLICATE_REPLACE = 'REPLACE';
export const DUPLICATE_ABORT = 'ABORT';
export const HIGH = 'HIGH';
export const LOW = 'LOW';
export const MIX = 'MIX';

export const ALL = "ALL";
export const MINE = "MINE";
export const FILE_EXTENSIONS = { video: ['mxf', 'mov', 'flv', 'wmv'] };
export const HEAD_BIN = -1;

export const RESTORE_STATUS = {
  HI_RES: '_hiResArchiveStatus',
  MID_RES: '_midResArchiveStatus',
  LOW_RES: '_lowResArchiveStatus'
};

export const SMART_COPY_PREFIX = 'SMART_COPY_PREFIX';
export const SMART_LAST_SELECTED = 'SMART_LAST_SELECTED'; //Last Selected Smart copy and link Path
export const BACK_TO_BTN = {
  BACK_TO_SRCH: 'BACK_TO_SEARCH',
  ADVANCED_SRCH: 'ADVANCED SEARCH'
};

export const archiveStatusEnum = {
  VAB_ARCHIVED: 'A',
  VAB_NOT_ARCHIVED: 'N',
  VAB_NOT_APPLICABLE: 'NA',
  VAB_PENDING: 'P',
  VAB_TRUE_ARCHIVE: 'TA',
  VAB_COPIED_TO_ARCHIVE: 'CA',
  COPIED_TO_GLACIER: 'AA'
};

export const archiveResolutions = {
  HI_RES: 'High-res',
  MID_RES: 'Mid-res',
  LOW_RES: 'Low-res',
  DIRECT: 'Direct'
};

export const UIActions = {
  RENAME: "Rename",
  MOVE: "Move",
  LOCK: "Lock",
  UNLOCK: "Unlock",
  ADD_TO_COLLECTION: "Add to Collection",
  REMOVE_FROM_COLLECTION: "Remove from Collection",
  NEW_COLLECTION: "New Collection",
  SHARE_AND_DOWNLOAD: "Share And Download",
  DOWNLOAD: "Download",
  CHECKOUT: "Checkout",
  UPDATE: "Update",
  VIEW_ASSET: "View Asset",
  REVEAL_IN_EXPLORER: "Reveal In Explorer",
  ARCHIVE: "Archive",
  RESTORE: "Restore",
  EDIT_METADATA: "Edit Metadata",
  EDIT_MENU: 'Edit',
  SMART_COPY: "Smart Copy",
  SMART_LINK: "Smart Link",
  DELETE: "Delete",
  RESURRECT: "Resurrect",
  UPLOAD: "Upload",
  DRAG_AND_DROP: "Drag And Drop",
  VIEW_SPOTLIGHT: "View Spotlight",
  ADD_TO_SPOTLIGHT: "Add to Spotlight",
  PURGE: "Purge",
  ADD_TO_FAVORITES: "Mark as Favorite",
  REMOVE_FROM_FAVORITES: "Remove from Favorite",
  VIEW_FAVORITES: "Favorites",
  COPY_ASSET_ID: "Copy Asset Id",
  COPY_URL: "Copy Url",
  COPY_ASSET_PATH: "Copy Asset Path",
  CROPPING: "Crop",
  CLIPPING: "Clip",
  DOWNLOAD_CLIP: "Download Clip",
  CREATE_NEW_ASSET: "Create New Asset",
  DOWNLOAD_XML_SEQUENCE: "Download XML Sequence",
  DOWNLOAD_AVID_CAPTIONS: "Download Avid Captions",
  DOWNLOAD_SRT: "Download SRT",
  DOWNLOAD_TEXT: "Download Text",
  CREATE_SEQUENCE_ASSET: "Create Sequence Asset",
  ADD_TEXT: "Add Text",
  PRESET_BASED_DOWNLOAD: "Preset based Download",
  ADD_DATA_TIMELINE: "Add Data Timeline",
  ADD_TIMELINE_ENTRY: "Add Timeline Entry",
  ADD_COMMENT: "Add Comment",
  EDIT_COMMENT: "Edit Comment",
  DELETE_COMMENT: "Delete Comment",
  MARK_COMMENT_AS_RESOLVED: "Mark Comment As Resolved",
  ADD_REPLY: "Add Reply",
  EDIT_REPLY: "Edit Reply",
  DELETE_REPLY: "Delete Reply",
  ARCHIVE_DETAILS: "Archive Details", //Check this
  COMPARE_VIEW: "Compare View",  //Check this
  FOLDER_DETAILS: "Folder Details", //Check this
  ASSET_DETAILS: "Asset Details",  //Check this
  VIEW_IN_ASSET_BROWSER: "View in Asset Browser",
  SHARE_VIA_EMAIL: "Share via E-mail",
  DELINK: "Delink",
  REMOVE_FROM_MEDIA_STORE: "Remove Local Copy",
  COPY_FROM_MEDIA_STORE_TO_S3: "Copy to Archive",
  COPY_FROM_S3_TO_MEDIA_STORE: "Restore From Archive",
  COPY_FROM_BACKUP_TO_S3: "Restore within S3",
  HIDE_COLLECTION: "Hide Collection",
  UNHIDE_COLLECTION: "Unhide Collection",
  DELETE_COLLECTION: "Delete Collection",
  CREATE_BIN: "Create Bin",
  RENAME_BIN: "Rename Bin",
  MOVE_TO_BIN: "Move to Bin",
  REMOVE_FROM_BIN: "Remove from Bin",
  RENAME_COLLECTION: "Rename Collection",
  DELETE_BIN: "Delete Bin",
  REACTIVATE_BIN: "Reactivate Bin",
  REACTIVATE_COLLECTION: "Reactivate Collection",
  MANAGE_EXTERNAL_ASSET: "Manage External Asset"
};

export const ZoomActions = {
  MOVE: "Move",
  RENAME: "Rename",
  LOCK: "Lock",
  UNLOCK: "Unlock",
  CHECKOUT: "Checkout",
  Delink: "Delink",
  CHECKIN: "Checkin",
  UPDATE: "Update",
  DELETE: "Delete",
  PURGE: "Purge",
  ARCHIVE: "Archive",
  RESTORE: "Restore",
  FLATTEN: "Flatten",
  NAVIGATION: "Navigation",
  PREVIEW: "Preview",
  EMBED_METADATA: "Embed Metadata",
  SET_METADATA: "Set Metadata",
  EDIT_METADATA: "Edit Metadata",
  COPY_DETAILS: "Copy Details",
  ADD_FOLDER: "Add Folder",
  FOLDER_DETAILS: "Folder Details",
  SMART_COPY: "Smart Copy",
  SMART_LINK: "Smart Link",
  CHANGE_THUMBNAIL: "Change Thumbnail",
  SEARCH: "Search",
  AI_DATA: "AI Data",
  CLIPPING: "Clipping",
  CROPPING: "Cropping",
  COMPARE_VIEW: "Compare View",
  DELINK: "Delink",
  MANAGE_EXTERNAL_ASSET: "Manage External Asset",
  ADD_TO_COLLECTION: "Add To Collection",
  REMOVE_FROM_COLLECTION: "Remove from Collection",
  SHARE_VIA_EMAIL: "Share via E-mail",
  ADD_TO_SPOTLIGHT: "Add to Spotlight",
  REMOVE_FROM_MEDIA_STORE: "Remove Local Copy",
  COPY_FROM_MEDIA_STORE_TO_S3: "Copy to Archive",
  COPY_FROM_S3_TO_MEDIA_STORE: "Restore From Archive",
  COPY_FROM_BACKUP_TO_S3: "Restore within S3"
};

export const CollectionActions = {
  RENAME_COLLECTION: "Rename Collection",
  CREATE_COLLECTION: "Create Collection",
  EDIT_COLLECTION: "Edit Collection",
  APPROVE_COLLECTION: "Approve Collection",
  DELETE_COLLECTION: "Delete Collection",
  VIEW_COLLECTION: "View Collection",
  DOWNLOAD_COLLECTION: "Download Collection",
  SHARE_COLLECTION: "Share Collection",
  ADD_TO_COLLECTION: "Add To Collection",
  REMOVE_FROM_COLLECTION: "Remove From Collection",
  COMMENTS: "Comments"
}

export const ZoomSettings = {
  CHANGE_DISPLAY_PICTURE: "Change Display Picture",
  CHANGE_PASSWORD: "Change Password",
  ADVANCE_SEARCH_COLUMNS: "Advanced Search Columns",
  DELETE_CONFIRMATION: "Delete Confirmation",
  DISABLE_SCRUB: "Disable Scrub",
  SHOW_ARCHIVED: "Show Archived",
  SHOW_DELETED: "Show Deleted",
  SHOW_EXPIRED: "Show Expired",
  LOG_LEVEL: "Log Level",
  ASSET_LIMIT_FOR_COLLECTION: "Asset Limit For Collection",
  DEFAULT_MODE: "Default Mode",
  OPEN_ASSET_AFTER_CHECKOUT: "Open Asset After Checkout",
  REFRESH_ON_FOCUS: "Refresh On Focus",
  SHOW_STATUS_ALERT: "Show Status Alert",
  SHOW_TOOL_TIP: "Show ToolTip",
  SMART_LINK_DELETE: "Smart Link Delete",
  DEFAULT_VIEW: "Default View",
  METADATA_PROPS_IN_VIEW: "Metadata Props In View",

  ACCEPT_WORKFLOW_TASK_WITH_CHECKOUT: "Accept Workflow Task With Checkout",
  ALL_LOCATIONS: "All Locations",
  ALWAYS_SHOW_PAGE_BAR: "Always Show Page Bar",
  ALWAYS_USE_S3_FOR_TRANSCODING: "Always Use S3 For Transcoding",
  ASK_DELETE_CONFIRMATION: "Ask Delete Confirmation",
  AUTO_CHECKIN_ON_UPLOAD: "Auto Checkin On Upload",
  AUTO_REFRESH_INTERVAL_IN_PLUGIN: "Auto Refresh Interval In Plugins",
  AUTOCO_MOUNT_POINT: "Auto Checkout Mount Point",
  BROWSE_SEARCH_SHOW_ARCHIVED: "Browse Search Show Archived",
  BROWSE_SEARCH_SHOW_DELETED: "Brow Search SHow Deleted",
  BROWSE_SEARCH_SHOW_EXPIRED: "Browse Search Show Expired",
  CHANGE_SELECTION_WITH_PREVIEW_NAVIGATION: "Change Selection With Preview Navigation",
  CURRENT_LOCALE: "Current Locale",
  DEFAULT_METADATA_LOAD_CHECKIN: "Default Metadata Loac Checkin",
  DEFAULT_UPDATE_ONLY_WC_ASSETS: "Default Update Only WC Assets",
  DISABLE_CHECKIN_BUTTON: "Disable Checkin Button",
  DISABLE_SEARCH_CATEGORIES_AUTO_SEARCH: "Disable Search Categories Auto Search",
  ENABLE_C3: "Enable C3",
  ENABLE_INGEST_PROXY: "Enable Ingest Proxy",
  EXCLUDE_PANEL_INDEX_OF_HOMESCREEN: "Exclude Panel Index Of HomeScreen",
  FIND_ALL_REVISIONS: "Find All Revisions",
  FIND_ONLY_FILES: "Find Only Files",
  FIND_ONLY_FOLDERS: "Find Only Files",
  FIND_SEARCH_SHOW_ARCHIVED: "Find Search SHow Archived",
  FIND_SEARCH_SHOW_DELETED: "Find Search Show Deleted",
  FIND_SEARCH_SHOW_EXPIRED: "Find Search Show Expired",
  FONT_INDEX: "Font Index",
  IGNORE_CHECKSUM_FOR_COPY: "Ignore Checksum For Copy",
  IGNORE_LOCKS_FOR_PURGE: "Ignore Locks For Purge",
  KEYWORD_HSCROLL: "Keyword HScroll",
  LINK_CONFIRMATION_ALERT: "Link Confirmation Alert",
  LIST_DEF_PROPS: "List Def Props",
  LOCK_CHECKOUT_SETTING: "Lock Checkout Setting",
  MODE: "Mode",
  NO_VERSION_CHECK: "No Version Check",
  ONLY_DELETE_FOR_PURGE: "Only Delete For Purge",
  PASSIVE_HUB: "Passive Hub",
  PENDING_S3_UPLOAD: "Pending S3 Upload",
  SHOW_BUSY_CURSOR_FOR_PATH_QUERY: "Show Busy Cursor For Path Query",
  SHOW_HUB_MENU_ITEM_ON_Z: "Show Hub Menu Item On Z",
  SHOW_MD_HEADER: "Show MD Header",
  SHOW_MD_PROP_FULLNAME: "Show MD Prop FullName",
  SHOW_REVISION_COMMENT: "Show Revision Comment",
  SMART_LINK_INCLUDE_IN_DELETE: "SMart Link Include in Delete",
  SMART_LINK_INCLUDE_IN_PURGE: "Smart Link Include In Purge",
  SMART_LINK_INCLUDE_IN_RESURRECT: "Smart Link Include In Resurrect",
  SMART_LINK_MAKE_WRITEABLE_DEFAULT: "Smart Link Make Writable Default",
  SYNCUP_ENABLED: "SyncUp Enabled",
  SYNCUP_PERIOD: "SyncUp Period",
  THIRD_PARTY_MOUNT_POINT: "Third Party Mount Point",
  THIRD_PARTY_MOUNT_POINT_AUTO: "Third Party Mount Point Auto",
  TREE_CLICK_DELAY: "Tree Click Delay",
  USAN_POINTS: "USAN Points",
  VAB_DEFAULT_GRID_VIEW_METADATA_LIST: "VAB Default Grid View Metadata List",
  VAB_DEFAULT_LIST_VIEW_METADATA_LIST: "VAB Default List View Metadata List",
  VAB_DEFAULT_VIEW: "VAB Default View",
  VAB_PREVIEW_FORMAT: "VAB Preview Format",
  ZOOM_SSL_TRUSTSTORE_PASSWORD: "Zoom SSL TrustSTore Password",
  ZOOM_SSL_TRUSTSTORE_PATH: "Zoom SSL TrustStore Path"
}

export const logsCategoryData = {
  "HUB-LOGS": "Hub Logs",
  "CLIENTPROXY": "",
  "HOT-FOLDER": "",
  "OTHER-LOGS": ""
}
